import { render } from "./CssdManagement.vue?vue&type=template&id=36ea3bc8&scoped=true"
import script from "./CssdManagement.vue?vue&type=script&lang=js"
export * from "./CssdManagement.vue?vue&type=script&lang=js"

import "./CssdManagement.vue?vue&type=style&index=0&id=36ea3bc8&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ea3bc8"]])

export default __exports__